import { Group, Menu, Text, UnstyledButton } from '@mantine/core'
import {
  IconCode,
  IconLogout,
  IconMessage,
  IconUser,
} from '@tabler/icons-react'
import { useRouteContext, useRouter } from '@tanstack/react-router'

export default function UserMenu() {
  const router = useRouter()
  const context = useRouteContext({ from: '/_auth' })
  return (
    <Menu shadow="md">
      <Menu.Target>
        <UnstyledButton>
          <Group gap="xs" align="center" pt={12}>
            <IconUser size="1rem" stroke={1.5} color="white" />
            <Text c="white" mr="md">
              {context.auth?.user?.username}
            </Text>
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {context.auth?.user?.name && (
          <Menu.Item>{context.auth?.user?.name}</Menu.Item>
        )}
        <Menu.Item
          leftSection={<IconMessage size="1rem" stroke="1.5" />}
          onClick={() => {
            router.navigate({
              to: '/user-messages',
              search: { pageNumber: 1, pageSize: 20 },
            })
          }}
        >
          ข้อความ
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            router.navigate({
              to: '/change-password',
            })
          }}
        >
          เปลี่ยน password
        </Menu.Item>
        <Menu.Item leftSection={<IconCode size="1rem" stroke="1.5" />}>
          <Text size="sm" c="dimmed">
            เวอร์ชัน: {__BUILD_VERSION__}
          </Text>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            context.auth?.logout().then(() => {
              context.queryClient.clear()
              router.navigate({
                to: '/',
              })
            })
          }}
          leftSection={<IconLogout size="1rem" stroke="1.5" />}
        >
          ออกจากระบบ
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
